import $ from 'jquery'

export const Popover = {
  HOOK_ROOT: '.js-popover',
  isActive: false,

  init: function () {
    $(document).on('click', Popover.HOOK_ROOT, Popover.click)
  },

  click: function (event) {
    event.preventDefault()

    const $currentTarget = $(this)

    // Check if there's an active popover
    if (Popover.isActive) {
      const targetActive = $currentTarget.hasClass('is-active')

      // Close the popover
      Popover.close(event, function () {
        // If a different target was being clicked open the new popover
        if (!targetActive) Popover.open(event, $currentTarget)
      })
    } else {
      // Open the new popover
      Popover.open(event, $currentTarget)
    }
  },

  open: function (event, $target) {
    // Set reference flags on what's active
    Popover.active = $target
    Popover.activeContainer = $target.data('popover')
    Popover.isActive = true

    $target.addClass('is-active')

    // Show the popover
    $(Popover.activeContainer).removeClass('is-hidden')

    // Bind body handler
    $(document).on('click', Popover.bodyClick)
  },

  close: function (event, callback) {
    // Hide popover and remove active state
    $(Popover.activeContainer).addClass('is-hidden')
    $(Popover.active).removeClass('is-active')

    // Unbind body click handler
    $(document).off('click', Popover.bodyClick)

    // Trigger close event to allow for custom logic elsewhere
    $(Popover.active).trigger('popover.close', event)

    // Clear active flags
    Popover.isActive = false
    Popover.active = null
    Popover.activeContainer = null

    if (callback) callback()
  },

  bodyClick: function (event) {
    const isActiveContainer = $(event.target).is(
      Popover.activeContainer + ' *, ' + Popover.activeContainer
    )
    const isTrigger = $(event.target).is(
      Popover.HOOK_ROOT + ' *, ' + Popover.HOOK_ROOT
    )

    // Close the popover if they're clicking the body
    if (!isActiveContainer && !isTrigger) Popover.close(event)
  },
}

$(Popover.init)
